export default {
    ON: 'ON',
    OFF: 'OFF',
};
